export default "__VITE_ASSET__CSmUomwS__"